import React from "react";
import PropTypes from "prop-types";
import "./SubHeader.scss";
import { useTheme } from "../../ContextStore/ThemeContext";

const Tab = ({ name, tab, Icon, active, onTabClick }) => {
  const { theme } = useTheme();

  const handleTabClick = e => {
    onTabClick(tab);
  };

  const getIconColor = (isActive, currentTheme) => {
    if (isActive) {
      return "#00B0EE";
    }
    return currentTheme === "dark" ? "#ffffff" : "#00050B";
  };

  const iconColor = React.useMemo(() => getIconColor(active, theme), [active, theme]);

  return (
    <button className={`tab ${active ? "active" : ""}`} onClick={handleTabClick}>
      <div className="tab_main">
        <Icon color={iconColor} />
        <span>{name}</span>
      </div>
    </button>
  );
};

Tab.propTypes = {
  name: PropTypes.string.isRequired,
  tab: PropTypes.object.isRequired,
  Icon: PropTypes.elementType.isRequired,
  active: PropTypes.bool.isRequired,
  onTabClick: PropTypes.func.isRequired
};

export const DetailPageMenu = ({ tabs, activeTab, onTabClick }) => {
  return (
    <div className="subheader">
      {tabs.map((tab, index) => (
        <Tab key={Number(index)} tab={tab} name={tab.title} Icon={tab.icon} active={activeTab === tab.title} onTabClick={onTabClick} />
      ))}
    </div>
  );
};

DetailPageMenu.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.elementType.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired
};
